import { createAction } from "~/utils/actions";

export default {
	...createAction("STEP_COMPLETED"),
};
